/**
 * Auto-generated phone_formats dataset — DO NOT EDIT MANUALLY.
 * Generated: 2026-07-14T15:38:23.355Z
 */

import type { IPhoneFormat } from '../types';

export const PHONE_FORMATS: IPhoneFormat[] = [
  {
    "countryCode": "AF",
    "iso2": "AF",
    "dialCode": "93",
    "patterns": "7\\d{8}",
    "possibleLengths": "9",
    "example": 701234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AX",
    "iso2": "AX",
    "dialCode": "358",
    "patterns": "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
    "possibleLengths": "[6-10]",
    "example": 412345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AL",
    "iso2": "AL",
    "dialCode": "355",
    "patterns": "6(?:[78][2-9]|9\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 672123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "DZ",
    "iso2": "DZ",
    "dialCode": "213",
    "patterns": "5(?:4[0-29]|6[0-4])\\d{6}|(?:55|6\\d|7[7-9])\\d{7}",
    "possibleLengths": "9",
    "example": 551234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AS",
    "iso2": "AS",
    "dialCode": "1",
    "patterns": "684(?:2(?:48|5[2468]|7[246])|7(?:3[13]|70|82))\\d{4}",
    "possibleLengths": "10",
    "example": 6847331234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "AD",
    "iso2": "AD",
    "dialCode": "376",
    "patterns": "690\\d{6}|[356]\\d{5}",
    "possibleLengths": "6,9",
    "example": 312345
  },
  {
    "countryCode": "AO",
    "iso2": "AO",
    "dialCode": "244",
    "patterns": "9[1-79]\\d{7}",
    "possibleLengths": "9",
    "example": 923123456
  },
  {
    "countryCode": "AI",
    "iso2": "AI",
    "dialCode": "1",
    "patterns": "264(?:235|4(?:69|7[67])|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
    "possibleLengths": "10",
    "example": 2642351234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "AQ",
    "iso2": "AQ",
    "dialCode": "672",
    "patterns": "\\d+",
    "possibleLengths": "[5-15]",
    "example": ""
  },
  {
    "countryCode": "AG",
    "iso2": "AG",
    "dialCode": "1",
    "patterns": "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",
    "possibleLengths": "10",
    "example": 2684641234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "AR",
    "iso2": "AR",
    "dialCode": "54",
    "patterns": "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
    "possibleLengths": "10,11",
    "example": 91123456789,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AM",
    "iso2": "AM",
    "dialCode": "374",
    "patterns": "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
    "possibleLengths": "8",
    "example": 77123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AW",
    "iso2": "AW",
    "dialCode": "297",
    "patterns": "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
    "possibleLengths": "7",
    "example": 5601234
  },
  {
    "countryCode": "AU",
    "iso2": "AU",
    "dialCode": "61",
    "patterns": "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
    "possibleLengths": "9",
    "example": 412345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AT",
    "iso2": "AT",
    "dialCode": "43",
    "patterns": "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
    "possibleLengths": "[7-13]",
    "example": 664123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AZ",
    "iso2": "AZ",
    "dialCode": "994",
    "patterns": "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
    "possibleLengths": "9",
    "example": 401234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "BH",
    "iso2": "BH",
    "dialCode": "973",
    "patterns": "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
    "possibleLengths": "8",
    "example": 36001234
  },
  {
    "countryCode": "BD",
    "iso2": "BD",
    "dialCode": "880",
    "patterns": "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
    "possibleLengths": "10",
    "example": 1812345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "BB",
    "iso2": "BB",
    "dialCode": "1",
    "patterns": "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",
    "possibleLengths": "10",
    "example": 2462501234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "BY",
    "iso2": "BY",
    "dialCode": "375",
    "patterns": "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 294911911,
    "nationalPrefix": "8"
  },
  {
    "countryCode": "BE",
    "iso2": "BE",
    "dialCode": "32",
    "patterns": "4[5-9]\\d{7}",
    "possibleLengths": "9",
    "example": 450001234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "BZ",
    "iso2": "BZ",
    "dialCode": "501",
    "patterns": "6[0-35-7]\\d{5}",
    "possibleLengths": "7",
    "example": 6221234
  },
  {
    "countryCode": "BJ",
    "iso2": "BJ",
    "dialCode": "229",
    "patterns": "01(?:2[5-9]|[4-69]\\d)\\d{6}",
    "possibleLengths": "10",
    "example": "0195123456"
  },
  {
    "countryCode": "BM",
    "iso2": "BM",
    "dialCode": "1",
    "patterns": "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}",
    "possibleLengths": "10",
    "example": 4413701234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "BT",
    "iso2": "BT",
    "dialCode": "975",
    "patterns": "(?:1[67]|[78]7)\\d{6}",
    "possibleLengths": "8",
    "example": 17123456
  },
  {
    "countryCode": "BO",
    "iso2": "BO",
    "dialCode": "591",
    "patterns": "(?:57|[67]\\d)\\d{6}",
    "possibleLengths": "8",
    "example": 71234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "BQ",
    "iso2": "BQ",
    "dialCode": "599",
    "patterns": "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",
    "possibleLengths": "7",
    "example": 3181234
  },
  {
    "countryCode": "BA",
    "iso2": "BA",
    "dialCode": "387",
    "patterns": "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
    "possibleLengths": "8,9",
    "example": 61123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "BW",
    "iso2": "BW",
    "dialCode": "267",
    "patterns": "(?:321|7(?:[1-8]\\d|9[03]))\\d{5}",
    "possibleLengths": "8",
    "example": 71123456
  },
  {
    "countryCode": "BV",
    "iso2": "BV",
    "dialCode": "0055",
    "patterns": "\\d+",
    "possibleLengths": "[5-15]",
    "example": ""
  },
  {
    "countryCode": "BR",
    "iso2": "BR",
    "dialCode": "55",
    "patterns": "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
    "possibleLengths": "10,11",
    "example": 11961234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "IO",
    "iso2": "IO",
    "dialCode": "246",
    "patterns": "38\\d{5}",
    "possibleLengths": "7",
    "example": 3801234
  },
  {
    "countryCode": "BN",
    "iso2": "BN",
    "dialCode": "673",
    "patterns": "(?:22[89]|[78]\\d\\d)\\d{4}",
    "possibleLengths": "7",
    "example": 7123456
  },
  {
    "countryCode": "BG",
    "iso2": "BG",
    "dialCode": "359",
    "patterns": "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
    "possibleLengths": "8,9",
    "example": 43012345,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "BF",
    "iso2": "BF",
    "dialCode": "226",
    "patterns": "(?:0[1-7]|4[4-6]|5[0-8]|[67]\\d)\\d{6}",
    "possibleLengths": "8",
    "example": 70123456
  },
  {
    "countryCode": "BI",
    "iso2": "BI",
    "dialCode": "257",
    "patterns": "(?:29|6[1-9]|7[125-9])\\d{6}",
    "possibleLengths": "8",
    "example": 79561234
  },
  {
    "countryCode": "KH",
    "iso2": "KH",
    "dialCode": "855",
    "patterns": "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
    "possibleLengths": "8,9",
    "example": 91234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "CM",
    "iso2": "CM",
    "dialCode": "237",
    "patterns": "(?:24[23]|6(?:[25-9]\\d|4[0-2]))\\d{6}",
    "possibleLengths": "9",
    "example": 671234567
  },
  {
    "countryCode": "CA",
    "iso2": "CA",
    "dialCode": "1",
    "patterns": "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
    "possibleLengths": "10",
    "example": 5062345678,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "CV",
    "iso2": "CV",
    "dialCode": "238",
    "patterns": "(?:36|5[1-389]|9\\d)\\d{5}",
    "possibleLengths": "7",
    "example": 9911234
  },
  {
    "countryCode": "KY",
    "iso2": "KY",
    "dialCode": "1",
    "patterns": "345(?:32[1-9]|4(?:1[2-6]|2[0-4])|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",
    "possibleLengths": "10",
    "example": 3453231234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "CF",
    "iso2": "CF",
    "dialCode": "236",
    "patterns": "7[02-7]\\d{6}",
    "possibleLengths": "8",
    "example": 70012345
  },
  {
    "countryCode": "TD",
    "iso2": "TD",
    "dialCode": "235",
    "patterns": "(?:3[01]|[69]\\d|77|8[5-7])\\d{6}",
    "possibleLengths": "8",
    "example": 63012345
  },
  {
    "countryCode": "CL",
    "iso2": "CL",
    "dialCode": "56",
    "patterns": "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:(?:[24]\\d|50)\\d|3(?:[034679]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389])|600)|646[59])|80[1-8]\\d\\d|9(?:(?:10[0-2]|7[1-9]\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
    "possibleLengths": "9",
    "example": 221234567
  },
  {
    "countryCode": "CN",
    "iso2": "CN",
    "dialCode": "86",
    "patterns": "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
    "possibleLengths": "11",
    "example": 13123456789,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "CX",
    "iso2": "CX",
    "dialCode": "61",
    "patterns": "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
    "possibleLengths": "9",
    "example": 412345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "CC",
    "iso2": "CC",
    "dialCode": "61",
    "patterns": "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
    "possibleLengths": "9",
    "example": 412345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "CO",
    "iso2": "CO",
    "dialCode": "57",
    "patterns": "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}",
    "possibleLengths": "10",
    "example": 3211234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "KM",
    "iso2": "KM",
    "dialCode": "269",
    "patterns": "[34]\\d{6}",
    "possibleLengths": "7",
    "example": 3212345
  },
  {
    "countryCode": "CG",
    "iso2": "CG",
    "dialCode": "242",
    "patterns": "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
    "possibleLengths": "9",
    "example": "061234567"
  },
  {
    "countryCode": "CK",
    "iso2": "CK",
    "dialCode": "682",
    "patterns": "[578]\\d{4}",
    "possibleLengths": "5",
    "example": 71234
  },
  {
    "countryCode": "CR",
    "iso2": "CR",
    "dialCode": "506",
    "patterns": "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
    "possibleLengths": "8",
    "example": 83123456
  },
  {
    "countryCode": "HR",
    "iso2": "HR",
    "dialCode": "385",
    "patterns": "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",
    "possibleLengths": "8,9",
    "example": 921234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "CU",
    "iso2": "CU",
    "dialCode": "53",
    "patterns": "(?:5\\d|6[2-4])\\d{6}",
    "possibleLengths": "8",
    "example": 51234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "CW",
    "iso2": "CW",
    "dialCode": "599",
    "patterns": "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
    "possibleLengths": "7,8",
    "example": 95181234
  },
  {
    "countryCode": "CY",
    "iso2": "CY",
    "dialCode": "357",
    "patterns": "9(?:10|[4-79]\\d)\\d{5}",
    "possibleLengths": "8",
    "example": 96123456
  },
  {
    "countryCode": "CZ",
    "iso2": "CZ",
    "dialCode": "420",
    "patterns": "7060\\d{5}|(?:60[1-8]|7(?:0[2-5]|19|[2379]\\d))\\d{6}",
    "possibleLengths": "9",
    "example": 601123456
  },
  {
    "countryCode": "CD",
    "iso2": "CD",
    "dialCode": "243",
    "patterns": "88\\d{5}|(?:8[0-69]|9[016-9])\\d{7}",
    "possibleLengths": "7,9",
    "example": 991234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "DK",
    "iso2": "DK",
    "dialCode": "45",
    "patterns": "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}",
    "possibleLengths": "8",
    "example": 34412345
  },
  {
    "countryCode": "DJ",
    "iso2": "DJ",
    "dialCode": "253",
    "patterns": "77\\d{6}",
    "possibleLengths": "8",
    "example": 77831001
  },
  {
    "countryCode": "DM",
    "iso2": "DM",
    "dialCode": "1",
    "patterns": "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
    "possibleLengths": "10",
    "example": 7672251234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "DO",
    "iso2": "DO",
    "dialCode": "1",
    "patterns": "8[024]9[2-9]\\d{6}",
    "possibleLengths": "10",
    "example": 8092345678,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "EC",
    "iso2": "EC",
    "dialCode": "593",
    "patterns": "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 991234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "EG",
    "iso2": "EG",
    "dialCode": "20",
    "patterns": "1[0-25]\\d{8}",
    "possibleLengths": "10",
    "example": 1001234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SV",
    "iso2": "SV",
    "dialCode": "503",
    "patterns": "[5-7]\\d{7}",
    "possibleLengths": "8",
    "example": 70123456
  },
  {
    "countryCode": "GQ",
    "iso2": "GQ",
    "dialCode": "240",
    "patterns": "(?:222|55\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 222123456
  },
  {
    "countryCode": "ER",
    "iso2": "ER",
    "dialCode": "291",
    "patterns": "(?:17[1-3]|7\\d\\d)\\d{4}",
    "possibleLengths": "7",
    "example": 7123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "EE",
    "iso2": "EE",
    "dialCode": "372",
    "patterns": "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|[2-79]\\d\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[013-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
    "possibleLengths": "7,8",
    "example": 51234567
  },
  {
    "countryCode": "SZ",
    "iso2": "SZ",
    "dialCode": "268",
    "patterns": "7[5-9]\\d{6}",
    "possibleLengths": "8",
    "example": 76123456
  },
  {
    "countryCode": "ET",
    "iso2": "ET",
    "dialCode": "251",
    "patterns": "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|2[1-35-79]|3\\d|77|86|99)|(?:8[01]|9\\d)\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 911234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "FK",
    "iso2": "FK",
    "dialCode": "500",
    "patterns": "[56]\\d{4}",
    "possibleLengths": "5",
    "example": 51234
  },
  {
    "countryCode": "FO",
    "iso2": "FO",
    "dialCode": "298",
    "patterns": "(?:[27][1-9]|5\\d|9[16])\\d{4}",
    "possibleLengths": "6",
    "example": 211234
  },
  {
    "countryCode": "FJ",
    "iso2": "FJ",
    "dialCode": "679",
    "patterns": "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
    "possibleLengths": "7",
    "example": 7012345
  },
  {
    "countryCode": "FI",
    "iso2": "FI",
    "dialCode": "358",
    "patterns": "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
    "possibleLengths": "[6-10]",
    "example": 412345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "FR",
    "iso2": "FR",
    "dialCode": "33",
    "patterns": "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 612345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "GF",
    "iso2": "GF",
    "dialCode": "594",
    "patterns": "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}",
    "possibleLengths": "9",
    "example": 694201234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "PF",
    "iso2": "PF",
    "dialCode": "689",
    "patterns": "8[7-9]\\d{6}",
    "possibleLengths": "8",
    "example": 87123456
  },
  {
    "countryCode": "TF",
    "iso2": "TF",
    "dialCode": "262",
    "patterns": "\\d+",
    "possibleLengths": "[5-15]",
    "example": ""
  },
  {
    "countryCode": "GA",
    "iso2": "GA",
    "dialCode": "241",
    "patterns": "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
    "possibleLengths": "7,8",
    "example": "06031234"
  },
  {
    "countryCode": "GE",
    "iso2": "GE",
    "dialCode": "995",
    "patterns": "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0(?:1[09]|70)|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|1[12]|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-6])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|4(?:44|55))|6[89]\\d\\d|7(?:(?:[0147-9]\\d|22)\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
    "possibleLengths": "9",
    "example": 555123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "DE",
    "iso2": "DE",
    "dialCode": "49",
    "patterns": "1(?:6[023]|7\\d)\\d{7,8}|15(?:[0-25-9]\\d\\d|3(?:10|33))\\d{6}",
    "possibleLengths": "10,11",
    "example": 15123456789,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "GH",
    "iso2": "GH",
    "dialCode": "233",
    "patterns": "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
    "possibleLengths": "9",
    "example": 231234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "GI",
    "iso2": "GI",
    "dialCode": "350",
    "patterns": "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
    "possibleLengths": "8",
    "example": 57123456
  },
  {
    "countryCode": "GR",
    "iso2": "GR",
    "dialCode": "30",
    "patterns": "68[57-9]\\d{7}|(?:69|94)\\d{8}",
    "possibleLengths": "10",
    "example": 6912345678
  },
  {
    "countryCode": "GL",
    "iso2": "GL",
    "dialCode": "299",
    "patterns": "[245]\\d{5}",
    "possibleLengths": "6",
    "example": 221234
  },
  {
    "countryCode": "GD",
    "iso2": "GD",
    "dialCode": "1",
    "patterns": "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}",
    "possibleLengths": "10",
    "example": 4734031234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "GP",
    "iso2": "GP",
    "dialCode": "590",
    "patterns": "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
    "possibleLengths": "9",
    "example": 690001234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "GU",
    "iso2": "GU",
    "dialCode": "1",
    "patterns": "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[16-9]))\\d{4}",
    "possibleLengths": "10",
    "example": 6713001234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "GT",
    "iso2": "GT",
    "dialCode": "502",
    "patterns": "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
    "possibleLengths": "8",
    "example": 51234567
  },
  {
    "countryCode": "GG",
    "iso2": "GG",
    "dialCode": "44",
    "patterns": "7(?:(?:781|839)\\d|911[17])\\d{5}",
    "possibleLengths": "10",
    "example": 7781123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "GN",
    "iso2": "GN",
    "dialCode": "224",
    "patterns": "6[0-356]\\d{7}",
    "possibleLengths": "9",
    "example": 601123456
  },
  {
    "countryCode": "GW",
    "iso2": "GW",
    "dialCode": "245",
    "patterns": "9(?:5\\d|6[569]|77)\\d{6}",
    "possibleLengths": "9",
    "example": 955012345
  },
  {
    "countryCode": "GY",
    "iso2": "GY",
    "dialCode": "592",
    "patterns": "(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[0-79]|[78]0))\\d{4}",
    "possibleLengths": "7",
    "example": 6091234
  },
  {
    "countryCode": "HT",
    "iso2": "HT",
    "dialCode": "509",
    "patterns": "(?:[34]\\d|5[568])\\d{6}",
    "possibleLengths": "8",
    "example": 34101234
  },
  {
    "countryCode": "HM",
    "iso2": "HM",
    "dialCode": "672",
    "patterns": "\\d+",
    "possibleLengths": "[5-15]",
    "example": ""
  },
  {
    "countryCode": "HN",
    "iso2": "HN",
    "dialCode": "504",
    "patterns": "[37-9]\\d{7}",
    "possibleLengths": "8",
    "example": 91234567
  },
  {
    "countryCode": "HK",
    "iso2": "HK",
    "dialCode": "852",
    "patterns": "(?:4(?:(?:09|24)[3-6]|44[0-35-9]|6(?:4[0-57-9]|6[0-6])|7(?:4[0-48]|6[0-5]))|5(?:25[3-7]|35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-467]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-35])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
    "possibleLengths": "8",
    "example": 51234567
  },
  {
    "countryCode": "HU",
    "iso2": "HU",
    "dialCode": "36",
    "patterns": "(?:[257]0|3[01])\\d{7}",
    "possibleLengths": "9",
    "example": 201234567,
    "nationalPrefix": "06"
  },
  {
    "countryCode": "IS",
    "iso2": "IS",
    "dialCode": "354",
    "patterns": "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
    "possibleLengths": "7,9",
    "example": 6111234
  },
  {
    "countryCode": "IN",
    "iso2": "IN",
    "dialCode": "91",
    "patterns": "(?:6(?:1279|828[01489])|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:160[01]|6(?:(?:12|[2-4]1|5[17]|6[13]|80)[0189]|7(?:1[0189]|86))|7(?:1(?:2[0189]|9[0-5])|3(?:2[5-8]|[34][017-9]|9[016-9])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:731|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|4[0189]|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-5])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:[024]\\d|3[05-8]|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}",
    "possibleLengths": "10",
    "example": 8123456789,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "ID",
    "iso2": "ID",
    "dialCode": "62",
    "patterns": "8[1-35-9]\\d{7,10}",
    "possibleLengths": "[9-12]",
    "example": 812345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "IR",
    "iso2": "IR",
    "dialCode": "98",
    "patterns": "9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:[01359]\\d|21|69|77|8[7-9])))\\d{5}",
    "possibleLengths": "10",
    "example": 9123456789,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "IQ",
    "iso2": "IQ",
    "dialCode": "964",
    "patterns": "7[3-9]\\d{8}",
    "possibleLengths": "10",
    "example": 7912345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "IE",
    "iso2": "IE",
    "dialCode": "353",
    "patterns": "8(?:22|[35-9]\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 850123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "IL",
    "iso2": "IL",
    "dialCode": "972",
    "patterns": "55(?:4(?:0[0-3]|[16]0)|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[3-5]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
    "possibleLengths": "9",
    "example": 502345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "IT",
    "iso2": "IT",
    "dialCode": "39",
    "patterns": "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
    "possibleLengths": "9,10",
    "example": 3123456789
  },
  {
    "countryCode": "CI",
    "iso2": "CI",
    "dialCode": "225",
    "patterns": "0[157]\\d{8}",
    "possibleLengths": "10",
    "example": "0123456789"
  },
  {
    "countryCode": "JM",
    "iso2": "JM",
    "dialCode": "1",
    "patterns": "(?:6582(?:[0-4]\\d|95)|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
    "possibleLengths": "10",
    "example": 8762101234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "JP",
    "iso2": "JP",
    "dialCode": "81",
    "patterns": "[6-9]0[1-9]\\d{7}",
    "possibleLengths": "10",
    "example": 9012345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "JE",
    "iso2": "JE",
    "dialCode": "44",
    "patterns": "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
    "possibleLengths": "10",
    "example": 7797712345,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "JO",
    "iso2": "JO",
    "dialCode": "962",
    "patterns": "(?:427|7(?:[78][0-25-9]|9\\d))\\d{6}",
    "possibleLengths": "9",
    "example": 790123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "KZ",
    "iso2": "KZ",
    "dialCode": "7",
    "patterns": "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
    "possibleLengths": "10",
    "example": 7710009998,
    "nationalPrefix": "8"
  },
  {
    "countryCode": "KE",
    "iso2": "KE",
    "dialCode": "254",
    "patterns": "(?:1(?:0[0-8]|1\\d|2[014]|30|4[0-5])|7\\d\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 712123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "KI",
    "iso2": "KI",
    "dialCode": "686",
    "patterns": "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
    "possibleLengths": "8",
    "example": 72001234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "XK",
    "iso2": "XK",
    "dialCode": "383",
    "patterns": "4[3-9]\\d{6}",
    "possibleLengths": "8",
    "example": 43201234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "KW",
    "iso2": "KW",
    "dialCode": "965",
    "patterns": "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
    "possibleLengths": "8",
    "example": 50012345
  },
  {
    "countryCode": "KG",
    "iso2": "KG",
    "dialCode": "996",
    "patterns": "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
    "possibleLengths": "9",
    "example": 700123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "LA",
    "iso2": "LA",
    "dialCode": "856",
    "patterns": "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}",
    "possibleLengths": "9,10",
    "example": 2023123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "LV",
    "iso2": "LV",
    "dialCode": "371",
    "patterns": "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}",
    "possibleLengths": "8",
    "example": 21234567
  },
  {
    "countryCode": "LB",
    "iso2": "LB",
    "dialCode": "961",
    "patterns": "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[0-4]))\\d{5}",
    "possibleLengths": "7,8",
    "example": 71123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "LS",
    "iso2": "LS",
    "dialCode": "266",
    "patterns": "[56]\\d{7}",
    "possibleLengths": "8",
    "example": 50123456
  },
  {
    "countryCode": "LR",
    "iso2": "LR",
    "dialCode": "231",
    "patterns": "(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
    "possibleLengths": "7,9",
    "example": 770123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "LY",
    "iso2": "LY",
    "dialCode": "218",
    "patterns": "9[1-6]\\d{7}",
    "possibleLengths": "9",
    "example": 912345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "LI",
    "iso2": "LI",
    "dialCode": "423",
    "patterns": "(?:6(?:(?:4[5-9]|5\\d)\\d|6(?:[024-68]\\d|1[01]|3[7-9]|70))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
    "possibleLengths": "7,9",
    "example": 660234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "LT",
    "iso2": "LT",
    "dialCode": "370",
    "patterns": "6\\d{7}",
    "possibleLengths": "8",
    "example": 61234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "LU",
    "iso2": "LU",
    "dialCode": "352",
    "patterns": "6(?:[26][18]|5[1568]|7[189]|81|9[128])\\d{6}",
    "possibleLengths": "9",
    "example": 628123456
  },
  {
    "countryCode": "MO",
    "iso2": "MO",
    "dialCode": "853",
    "patterns": "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
    "possibleLengths": "8",
    "example": 66123456
  },
  {
    "countryCode": "MG",
    "iso2": "MG",
    "dialCode": "261",
    "patterns": "3[2-9]\\d{7}",
    "possibleLengths": "9",
    "example": 321234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MW",
    "iso2": "MW",
    "dialCode": "265",
    "patterns": "111\\d{6}|(?:2[12]|31|77|[89][89])\\d{7}",
    "possibleLengths": "9",
    "example": 991234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MY",
    "iso2": "MY",
    "dialCode": "60",
    "patterns": "1(?:(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|9\\d{7,8})|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-79]|6[02-4]|8[02-5]))|(?:[26]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
    "possibleLengths": "9,10",
    "example": 123456789,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MV",
    "iso2": "MV",
    "dialCode": "960",
    "patterns": "(?:46[46]|[79]\\d\\d)\\d{4}",
    "possibleLengths": "7",
    "example": 7712345
  },
  {
    "countryCode": "ML",
    "iso2": "ML",
    "dialCode": "223",
    "patterns": "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}",
    "possibleLengths": "8",
    "example": 65012345
  },
  {
    "countryCode": "MT",
    "iso2": "MT",
    "dialCode": "356",
    "patterns": "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
    "possibleLengths": "8",
    "example": 96961234
  },
  {
    "countryCode": "IM",
    "iso2": "IM",
    "dialCode": "44",
    "patterns": "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
    "possibleLengths": "10",
    "example": 7924123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MH",
    "iso2": "MH",
    "dialCode": "692",
    "patterns": "(?:(?:23|54)5|329|45[35-8])\\d{4}",
    "possibleLengths": "7",
    "example": 2351234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "MQ",
    "iso2": "MQ",
    "dialCode": "596",
    "patterns": "(?:69[67]\\d\\d|7091[0-3])\\d{4}",
    "possibleLengths": "9",
    "example": 696201234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MR",
    "iso2": "MR",
    "dialCode": "222",
    "patterns": "[2-4][0-46-9]\\d{6}",
    "possibleLengths": "8",
    "example": 22123456
  },
  {
    "countryCode": "MU",
    "iso2": "MU",
    "dialCode": "230",
    "patterns": "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-7]|3[013]))\\d{5}",
    "possibleLengths": "8",
    "example": 52512345
  },
  {
    "countryCode": "YT",
    "iso2": "YT",
    "dialCode": "262",
    "patterns": "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}",
    "possibleLengths": "9",
    "example": 639012345,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MX",
    "iso2": "MX",
    "dialCode": "52",
    "patterns": "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
    "possibleLengths": "10",
    "example": 2221234567
  },
  {
    "countryCode": "FM",
    "iso2": "FM",
    "dialCode": "691",
    "patterns": "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
    "possibleLengths": "7",
    "example": 3501234
  },
  {
    "countryCode": "MD",
    "iso2": "MD",
    "dialCode": "373",
    "patterns": "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
    "possibleLengths": "8",
    "example": 62112345,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MC",
    "iso2": "MC",
    "dialCode": "377",
    "patterns": "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|[67]\\d)\\d{7}",
    "possibleLengths": "8,9",
    "example": 612345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MN",
    "iso2": "MN",
    "dialCode": "976",
    "patterns": "(?:87[01]|92[0139])\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}",
    "possibleLengths": "8",
    "example": 88123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "ME",
    "iso2": "ME",
    "dialCode": "382",
    "patterns": "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
    "possibleLengths": "8",
    "example": 60123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MS",
    "iso2": "MS",
    "dialCode": "1",
    "patterns": "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",
    "possibleLengths": "10",
    "example": 6644923456,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "MA",
    "iso2": "MA",
    "dialCode": "212",
    "patterns": "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}",
    "possibleLengths": "9",
    "example": 650123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MZ",
    "iso2": "MZ",
    "dialCode": "258",
    "patterns": "8(?:[2-79]\\d|80)\\d{6}",
    "possibleLengths": "9",
    "example": 821234567
  },
  {
    "countryCode": "MM",
    "iso2": "MM",
    "dialCode": "95",
    "patterns": "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
    "possibleLengths": "[7-10]",
    "example": 92123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "NA",
    "iso2": "NA",
    "dialCode": "264",
    "patterns": "(?:60|8[1245])\\d{7}",
    "possibleLengths": "9",
    "example": 811234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "NR",
    "iso2": "NR",
    "dialCode": "674",
    "patterns": "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}",
    "possibleLengths": "7",
    "example": 5551234
  },
  {
    "countryCode": "NP",
    "iso2": "NP",
    "dialCode": "977",
    "patterns": "9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}",
    "possibleLengths": "10",
    "example": 9841234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "NL",
    "iso2": "NL",
    "dialCode": "31",
    "patterns": "(?:6[1-58]|970\\d)\\d{7}",
    "possibleLengths": "9,11",
    "example": 612345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "NC",
    "iso2": "NC",
    "dialCode": "687",
    "patterns": "(?:[579]\\d|8[0-79])\\d{4}",
    "possibleLengths": "6",
    "example": 751234
  },
  {
    "countryCode": "NZ",
    "iso2": "NZ",
    "dialCode": "64",
    "patterns": "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
    "possibleLengths": "[8-10]",
    "example": 211234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "NI",
    "iso2": "NI",
    "dialCode": "505",
    "patterns": "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
    "possibleLengths": "8",
    "example": 81234567
  },
  {
    "countryCode": "NE",
    "iso2": "NE",
    "dialCode": "227",
    "patterns": "(?:23|7[0467]|[89]\\d)\\d{6}",
    "possibleLengths": "8",
    "example": 93123456
  },
  {
    "countryCode": "NG",
    "iso2": "NG",
    "dialCode": "234",
    "patterns": "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
    "possibleLengths": "10",
    "example": 8021234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "NU",
    "iso2": "NU",
    "dialCode": "683",
    "patterns": "(?:[56]|888[1-9])\\d{3}",
    "possibleLengths": "4,7",
    "example": 8884012
  },
  {
    "countryCode": "NF",
    "iso2": "NF",
    "dialCode": "672",
    "patterns": "(?:14|3[58])\\d{4}",
    "possibleLengths": "6",
    "example": 381234
  },
  {
    "countryCode": "KP",
    "iso2": "KP",
    "dialCode": "850",
    "patterns": "19[1-3]\\d{7}",
    "possibleLengths": "10",
    "example": 1921234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MK",
    "iso2": "MK",
    "dialCode": "389",
    "patterns": "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
    "possibleLengths": "8",
    "example": 72345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MP",
    "iso2": "MP",
    "dialCode": "1",
    "patterns": "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
    "possibleLengths": "10",
    "example": 6702345678,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "NO",
    "iso2": "NO",
    "dialCode": "47",
    "patterns": "[49]\\d{7}",
    "possibleLengths": "8",
    "example": 40612345
  },
  {
    "countryCode": "OM",
    "iso2": "OM",
    "dialCode": "968",
    "patterns": "(?:1505|90[1-9]\\d)\\d{4}|(?:7[124-9]|9[1-9])\\d{6}",
    "possibleLengths": "8",
    "example": 92123456
  },
  {
    "countryCode": "PK",
    "iso2": "PK",
    "dialCode": "92",
    "patterns": "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
    "possibleLengths": "10",
    "example": 3012345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "PW",
    "iso2": "PW",
    "dialCode": "680",
    "patterns": "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}",
    "possibleLengths": "7",
    "example": 6201234
  },
  {
    "countryCode": "PS",
    "iso2": "PS",
    "dialCode": "970",
    "patterns": "5[69]\\d{7}",
    "possibleLengths": "9",
    "example": 599123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "PA",
    "iso2": "PA",
    "dialCode": "507",
    "patterns": "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
    "possibleLengths": "7,8",
    "example": 61234567
  },
  {
    "countryCode": "PG",
    "iso2": "PG",
    "dialCode": "675",
    "patterns": "(?:7\\d|8[1-48])\\d{6}",
    "possibleLengths": "8",
    "example": 70123456
  },
  {
    "countryCode": "PY",
    "iso2": "PY",
    "dialCode": "595",
    "patterns": "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
    "possibleLengths": "9",
    "example": 961456789,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "PE",
    "iso2": "PE",
    "dialCode": "51",
    "patterns": "9\\d{8}",
    "possibleLengths": "9",
    "example": 912345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "PH",
    "iso2": "PH",
    "dialCode": "63",
    "patterns": "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
    "possibleLengths": "10",
    "example": 9051234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "PN",
    "iso2": "PN",
    "dialCode": "870",
    "patterns": "\\d+",
    "possibleLengths": "[5-15]",
    "example": ""
  },
  {
    "countryCode": "PL",
    "iso2": "PL",
    "dialCode": "48",
    "patterns": "21(?:1[013-5]|2\\d|3[1-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
    "possibleLengths": "9",
    "example": 512345678
  },
  {
    "countryCode": "PT",
    "iso2": "PT",
    "dialCode": "351",
    "patterns": "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
    "possibleLengths": "9",
    "example": 912345678
  },
  {
    "countryCode": "PR",
    "iso2": "PR",
    "dialCode": "1",
    "patterns": "(?:787|939)[2-9]\\d{6}",
    "possibleLengths": "10",
    "example": 7872345678,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "QA",
    "iso2": "QA",
    "dialCode": "974",
    "patterns": "[35-7]\\d{7}",
    "possibleLengths": "8",
    "example": 33123456
  },
  {
    "countryCode": "RE",
    "iso2": "RE",
    "dialCode": "262",
    "patterns": "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
    "possibleLengths": "9",
    "example": 692123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "RO",
    "iso2": "RO",
    "dialCode": "40",
    "patterns": "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
    "possibleLengths": "9",
    "example": 712034567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "RU",
    "iso2": "RU",
    "dialCode": "7",
    "patterns": "9\\d{9}",
    "possibleLengths": "10",
    "example": 9123456789,
    "nationalPrefix": "8"
  },
  {
    "countryCode": "RW",
    "iso2": "RW",
    "dialCode": "250",
    "patterns": "7[237-9]\\d{7}",
    "possibleLengths": "9",
    "example": 720123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SH",
    "iso2": "SH",
    "dialCode": "290",
    "patterns": "[56]\\d{4}",
    "possibleLengths": "5",
    "example": 51234
  },
  {
    "countryCode": "KN",
    "iso2": "KN",
    "dialCode": "1",
    "patterns": "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",
    "possibleLengths": "10",
    "example": 8697652917,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "LC",
    "iso2": "LC",
    "dialCode": "1",
    "patterns": "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",
    "possibleLengths": "10",
    "example": 7582845678,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "PM",
    "iso2": "PM",
    "dialCode": "508",
    "patterns": "708(?:4[0-5]|5[0-6])\\d{4}|(?:[236-9]\\d|4[02-489]|5[02-9])\\d{4}",
    "possibleLengths": "6,9",
    "example": 551234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "VC",
    "iso2": "VC",
    "dialCode": "1",
    "patterns": "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",
    "possibleLengths": "10",
    "example": 7844301234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "BL",
    "iso2": "BL",
    "dialCode": "590",
    "patterns": "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
    "possibleLengths": "9",
    "example": 690001234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "MF",
    "iso2": "MF",
    "dialCode": "590",
    "patterns": "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
    "possibleLengths": "9",
    "example": 690001234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "WS",
    "iso2": "WS",
    "dialCode": "685",
    "patterns": "(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}",
    "possibleLengths": "7,10",
    "example": 7212345
  },
  {
    "countryCode": "SM",
    "iso2": "SM",
    "dialCode": "378",
    "patterns": "6[16]\\d{6}",
    "possibleLengths": "8",
    "example": 66661212
  },
  {
    "countryCode": "ST",
    "iso2": "ST",
    "dialCode": "239",
    "patterns": "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
    "possibleLengths": "7",
    "example": 9812345
  },
  {
    "countryCode": "SA",
    "iso2": "SA",
    "dialCode": "966",
    "patterns": "579[0-8]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
    "possibleLengths": "9",
    "example": 512345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SN",
    "iso2": "SN",
    "dialCode": "221",
    "patterns": "7(?:[015-8]\\d|21|90)\\d{6}",
    "possibleLengths": "9",
    "example": 701234567
  },
  {
    "countryCode": "RS",
    "iso2": "RS",
    "dialCode": "381",
    "patterns": "6(?:[0-689]|7\\d)\\d{6,7}",
    "possibleLengths": "[8-10]",
    "example": 601234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SC",
    "iso2": "SC",
    "dialCode": "248",
    "patterns": "2[125-8]\\d{5}",
    "possibleLengths": "7",
    "example": 2510123
  },
  {
    "countryCode": "SL",
    "iso2": "SL",
    "dialCode": "232",
    "patterns": "(?:25|3[0-5]|66|7\\d|8[08]|9[09])\\d{6}",
    "possibleLengths": "8",
    "example": 25123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SG",
    "iso2": "SG",
    "dialCode": "65",
    "patterns": "80[1-9]\\d{5}|(?:8[1-9]|9[0-8])\\d{6}",
    "possibleLengths": "8",
    "example": 81234567
  },
  {
    "countryCode": "SX",
    "iso2": "SX",
    "dialCode": "1721",
    "patterns": "7215(?:1[02]|2\\d|5[034679]|8[0-24-8])\\d{4}",
    "possibleLengths": "10",
    "example": 7215205678,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "SK",
    "iso2": "SK",
    "dialCode": "421",
    "patterns": "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
    "possibleLengths": "9",
    "example": 912123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SI",
    "iso2": "SI",
    "dialCode": "386",
    "patterns": "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[013]|51|6[489])\\d{6}",
    "possibleLengths": "8",
    "example": 31234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SB",
    "iso2": "SB",
    "dialCode": "677",
    "patterns": "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
    "possibleLengths": "5,7",
    "example": 7421234
  },
  {
    "countryCode": "SO",
    "iso2": "SO",
    "dialCode": "252",
    "patterns": "(?:(?:15|(?:3[59]|4[89]|6\\d|7[0-35-9]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
    "possibleLengths": "[7-9]",
    "example": 71123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "ZA",
    "iso2": "ZA",
    "dialCode": "27",
    "patterns": "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|[67]\\d\\d)\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
    "possibleLengths": "[5-9]",
    "example": 711234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "GS",
    "iso2": "GS",
    "dialCode": "500",
    "patterns": "\\d+",
    "possibleLengths": "[5-15]",
    "example": ""
  },
  {
    "countryCode": "KR",
    "iso2": "KR",
    "dialCode": "82",
    "patterns": "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
    "possibleLengths": "9,10",
    "example": 1020000000,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SS",
    "iso2": "SS",
    "dialCode": "211",
    "patterns": "(?:12|9[1257-9])\\d{7}",
    "possibleLengths": "9",
    "example": 977123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "ES",
    "iso2": "ES",
    "dialCode": "34",
    "patterns": "96906(?:09|10)\\d\\d|(?:590(?:10[0-2]|600)|97390\\d)\\d{3}|(?:6\\d|7[1-48])\\d{7}",
    "possibleLengths": "9",
    "example": 612345678
  },
  {
    "countryCode": "LK",
    "iso2": "LK",
    "dialCode": "94",
    "patterns": "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
    "possibleLengths": "9",
    "example": 712345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SD",
    "iso2": "SD",
    "dialCode": "249",
    "patterns": "(?:1[0-2]|9[0-3569])\\d{7}",
    "possibleLengths": "9",
    "example": 911231234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SR",
    "iso2": "SR",
    "dialCode": "597",
    "patterns": "(?:6[08]|7[1-7]|8[1-9])\\d{5}",
    "possibleLengths": "7",
    "example": 7412345
  },
  {
    "countryCode": "SJ",
    "iso2": "SJ",
    "dialCode": "47",
    "patterns": "[49]\\d{7}",
    "possibleLengths": "8",
    "example": 41234567
  },
  {
    "countryCode": "SE",
    "iso2": "SE",
    "dialCode": "46",
    "patterns": "7[02369]\\d{7}",
    "possibleLengths": "9",
    "example": 701234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "CH",
    "iso2": "CH",
    "dialCode": "41",
    "patterns": "(?:6[89]|7[235-9])\\d{7}",
    "possibleLengths": "9",
    "example": 781234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "SY",
    "iso2": "SY",
    "dialCode": "963",
    "patterns": "(?:50|9[1-9])\\d{7}",
    "possibleLengths": "9",
    "example": 944567890,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "TW",
    "iso2": "TW",
    "dialCode": "886",
    "patterns": "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
    "possibleLengths": "9",
    "example": 912345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "TJ",
    "iso2": "TJ",
    "dialCode": "992",
    "patterns": "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|3[08]|40|5[05]|66|7[0157-9]|8[07-9])\\d{7}",
    "possibleLengths": "9",
    "example": 917123456
  },
  {
    "countryCode": "TZ",
    "iso2": "TZ",
    "dialCode": "255",
    "patterns": "(?:6[1-35-9]|7\\d)\\d{7}",
    "possibleLengths": "9",
    "example": 621234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "TH",
    "iso2": "TH",
    "dialCode": "66",
    "patterns": "(?:(?:14|[89]\\d)\\d\\d|6(?:[1-6]\\d\\d|7(?:1[0-8]|2[4-7]|3[1-6])))\\d{5}",
    "possibleLengths": "9",
    "example": 812345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "BS",
    "iso2": "BS",
    "dialCode": "1",
    "patterns": "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
    "possibleLengths": "10",
    "example": 2423591234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "GM",
    "iso2": "GM",
    "dialCode": "220",
    "patterns": "556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[4-7])\\d{5}",
    "possibleLengths": "7",
    "example": 3012345
  },
  {
    "countryCode": "TL",
    "iso2": "TL",
    "dialCode": "670",
    "patterns": "7[2-8]\\d{6}",
    "possibleLengths": "8",
    "example": 77212345
  },
  {
    "countryCode": "TG",
    "iso2": "TG",
    "dialCode": "228",
    "patterns": "(?:7[0-289]|9[0-36-9])\\d{6}",
    "possibleLengths": "8",
    "example": 90112345
  },
  {
    "countryCode": "TK",
    "iso2": "TK",
    "dialCode": "690",
    "patterns": "7[2-4]\\d{2,5}",
    "possibleLengths": "[4-7]",
    "example": 7290
  },
  {
    "countryCode": "TO",
    "iso2": "TO",
    "dialCode": "676",
    "patterns": "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
    "possibleLengths": "7",
    "example": 7715123
  },
  {
    "countryCode": "TT",
    "iso2": "TT",
    "dialCode": "1",
    "patterns": "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
    "possibleLengths": "10",
    "example": 8682911234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "TN",
    "iso2": "TN",
    "dialCode": "216",
    "patterns": "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
    "possibleLengths": "8",
    "example": 20123456
  },
  {
    "countryCode": "TR",
    "iso2": "TR",
    "dialCode": "90",
    "patterns": "561(?:011|61\\d)\\d{4}|5(?:[03-5]\\d|1[06]|24|6[24]|7[245]|9[46])\\d{7}",
    "possibleLengths": "10",
    "example": 5012345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "TM",
    "iso2": "TM",
    "dialCode": "993",
    "patterns": "(?:6\\d|7[12])\\d{6}",
    "possibleLengths": "8",
    "example": 66123456,
    "nationalPrefix": "8"
  },
  {
    "countryCode": "TC",
    "iso2": "TC",
    "dialCode": "1",
    "patterns": "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
    "possibleLengths": "10",
    "example": 6492311234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "TV",
    "iso2": "TV",
    "dialCode": "688",
    "patterns": "(?:7[01]\\d|90)\\d{4}",
    "possibleLengths": "6,7",
    "example": 901234
  },
  {
    "countryCode": "UG",
    "iso2": "UG",
    "dialCode": "256",
    "patterns": "7280\\d{5}|7(?:[014-8]\\d|2[01467]|3[016]|9[0-589])\\d{6}",
    "possibleLengths": "9",
    "example": 712345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "UA",
    "iso2": "UA",
    "dialCode": "380",
    "patterns": "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
    "possibleLengths": "9",
    "example": 501234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "AE",
    "iso2": "AE",
    "dialCode": "971",
    "patterns": "5[02-68]\\d{7}",
    "possibleLengths": "9",
    "example": 501234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "GB",
    "iso2": "GB",
    "dialCode": "44",
    "patterns": "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
    "possibleLengths": "10",
    "example": 7400123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "US",
    "iso2": "US",
    "dialCode": "1",
    "patterns": "(?:472[2-47-9]|983[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[02469]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
    "possibleLengths": "10",
    "example": 2015550123,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "UM",
    "iso2": "UM",
    "dialCode": "1",
    "patterns": "\\d+",
    "possibleLengths": "[5-15]",
    "example": ""
  },
  {
    "countryCode": "UY",
    "iso2": "UY",
    "dialCode": "598",
    "patterns": "9[1-9]\\d{6}",
    "possibleLengths": "8",
    "example": 94231234,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "UZ",
    "iso2": "UZ",
    "dialCode": "998",
    "patterns": "(?:(?:[25]0|33|8[078]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
    "possibleLengths": "9",
    "example": 912345678
  },
  {
    "countryCode": "VU",
    "iso2": "VU",
    "dialCode": "678",
    "patterns": "(?:[58]\\d|7[0-7])\\d{5}",
    "possibleLengths": "7",
    "example": 5912345
  },
  {
    "countryCode": "VA",
    "iso2": "VA",
    "dialCode": "379",
    "patterns": "3[1-9]\\d{8}|3[2-9]\\d{7}",
    "possibleLengths": "9,10",
    "example": 3123456789
  },
  {
    "countryCode": "VE",
    "iso2": "VE",
    "dialCode": "58",
    "patterns": "4(?:1[24-8]|2[246])\\d{7}",
    "possibleLengths": "10",
    "example": 4121234567,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "VN",
    "iso2": "VN",
    "dialCode": "84",
    "patterns": "121[0-3]\\d{5}|(?:160|(?:3\\d|7[06-9])\\d|5(?:[1689]\\d|2[238]|59)|8(?:[1-8]\\d|9[6-9])|9(?:[0-8]\\d|9[013-9]))\\d{6}",
    "possibleLengths": "9",
    "example": 912345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "VG",
    "iso2": "VG",
    "dialCode": "1",
    "patterns": "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",
    "possibleLengths": "10",
    "example": 2843001234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "VI",
    "iso2": "VI",
    "dialCode": "1",
    "patterns": "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
    "possibleLengths": "10",
    "example": 3406421234,
    "nationalPrefix": "1"
  },
  {
    "countryCode": "WF",
    "iso2": "WF",
    "dialCode": "681",
    "patterns": "(?:72|8[23])\\d{4}",
    "possibleLengths": "6",
    "example": 821234
  },
  {
    "countryCode": "EH",
    "iso2": "EH",
    "dialCode": "212",
    "patterns": "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}",
    "possibleLengths": "9",
    "example": 650123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "YE",
    "iso2": "YE",
    "dialCode": "967",
    "patterns": "7[01378]\\d{7}",
    "possibleLengths": "9",
    "example": 712345678,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "ZM",
    "iso2": "ZM",
    "dialCode": "260",
    "patterns": "(?:[59][5-8]|7[5-9])\\d{7}",
    "possibleLengths": "9",
    "example": 955123456,
    "nationalPrefix": "0"
  },
  {
    "countryCode": "ZW",
    "iso2": "ZW",
    "dialCode": "263",
    "patterns": "7(?:[1278]\\d|3[1-9])\\d{6}",
    "possibleLengths": "9",
    "example": 712345678,
    "nationalPrefix": "0"
  }
];

export default PHONE_FORMATS;
